module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "start"
    }
  }, [_c('a', {
    attrs: {
      "id": "chap1"
    }
  }, [_vm._v("ONE")])]), _c('a', {
    attrs: {
      "id": "chap1"
    }
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS STORY BEGINS VERY")]), _vm._v(" soon after the world began, when great raw things called monsters roamed the unfinished places eating whatever they could catch. The earth was flat then, as anyone could tell; it had been broken into islands and the pieces flung upon a huge puddle of sea. The islands bobbed uneasily on the heaving purple water and had to be pinned down by mountains or they would have blown away altogether; that’s how strong the winds were.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("On top of one of these mountains, called Olympus, lived a family of gods. They had chosen Olympus because it was high enough to look down upon the pasture lands of the restless new herds they had inherited: strange, wild, and clever creatures, neither god nor beast but something in between, who called themselves men and women and were difficult to manage.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The gods loved to hunt and soon found that men and women, although lacking horns or claws and absurdly slow-footed, nevertheless offered fine sport, for human prey, unlike any other, kept trying to understand what was happening to them. But, try as they might, they could make no sense of these arrows that struck out of nowhere, taking the young and strong as well as the old and feeble. And their anguished confusion amused the gods mightily.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Finally, Zeus, the king of the gods, saw that the human herd was shrinking before the invisible arrows faster than it could replace itself, and he decided to lay down some game laws. It was forbidden to kill more than a certain small quota of humans each month, and the penalties were severe. He decreed that anyone who broke the new law would be chained to the roots of a mountain in Tartarus and kept there in suffocating darkness through eternity.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The gods feared Zeus. They knew how ferocious he could be when crossed. So they pretended to obey. But as time passed, they found a way to break the law without suffering the penalties.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They employed monsters—particularly dragons, who developed a taste for heroes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And now that we know something about the games gods play, and the reason for dragons, we can better follow the adventures of those who shipped with Jason on his quest for the Golden Fleece.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7076db82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5start.vue
// module id = 69
// module chunks = 0